/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cover_Letters_Empty_DescInputs */

const en_cover_letters_empty_desc = /** @type {(inputs: Cover_Letters_Empty_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate one from a job + resume combination.`)
};

const de_cover_letters_empty_desc = /** @type {(inputs: Cover_Letters_Empty_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generiere eines aus einer Kombination von Stelle und Lebenslauf.`)
};

const fr_cover_letters_empty_desc = /** @type {(inputs: Cover_Letters_Empty_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Génère-en une à partir d'une combinaison emploi + CV.`)
};

const es_cover_letters_empty_desc = /** @type {(inputs: Cover_Letters_Empty_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genere una a partir de una combinación de empleo + currículum.`)
};

const it_cover_letters_empty_desc = /** @type {(inputs: Cover_Letters_Empty_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generane una da una combinazione di lavoro + curriculum.`)
};

const nl_cover_letters_empty_desc = /** @type {(inputs: Cover_Letters_Empty_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genereer er een uit een baan + CV-combinatie.`)
};

const pl_cover_letters_empty_desc = /** @type {(inputs: Cover_Letters_Empty_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wygeneruj jeden z kombinacji oferty pracy + CV.`)
};

const fi_cover_letters_empty_desc = /** @type {(inputs: Cover_Letters_Empty_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luo saatekirje työpaikan ja ansioluettelon yhdistelmästä.`)
};

const da_cover_letters_empty_desc = /** @type {(inputs: Cover_Letters_Empty_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generer et fra en job + CV-kombination.`)
};

const sv_cover_letters_empty_desc = /** @type {(inputs: Cover_Letters_Empty_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generera ett från en jobb + CV-kombination.`)
};

/**
* | output |
* | --- |
* | "Generate one from a job + resume combination." |
*
* @param {Cover_Letters_Empty_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const cover_letters_empty_desc = /** @type {((inputs?: Cover_Letters_Empty_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cover_Letters_Empty_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cover_letters_empty_desc(inputs)
	if (locale === "fr") return fr_cover_letters_empty_desc(inputs)
	if (locale === "es") return es_cover_letters_empty_desc(inputs)
	if (locale === "it") return it_cover_letters_empty_desc(inputs)
	if (locale === "nl") return nl_cover_letters_empty_desc(inputs)
	if (locale === "pl") return pl_cover_letters_empty_desc(inputs)
	if (locale === "fi") return fi_cover_letters_empty_desc(inputs)
	if (locale === "da") return da_cover_letters_empty_desc(inputs)
	if (locale === "sv") return sv_cover_letters_empty_desc(inputs)
	return en_cover_letters_empty_desc(inputs)
});